<!--  -->
<template>
  <div>
    <Paperdetails ref="detailKey" :detailValue="detailValue"></Paperdetails>
    <Papercomment ref="commentKey" :commentValue="commentValue"></Papercomment>
    <Paperotherresult ref="resultKey" :resultValue="resultValue"></Paperotherresult>
    <Paperclaim ref="claimKey" :claimValue="claimValue"></Paperclaim>
    <Papererror ref="errorKey" :errorValue="errorValue"></Papererror>
    <div class="wallhaven">
      <div class="container clearf">
        <div class="wallhaven-img clearf">
          <img :src="authorObj.iavater" alt>
        </div>
        <div class="wallhaven-intro">
          <div class="intro-route">{{substr}}</div>
          <div class="intro-author">
            <span class="author">
              {{authorObj.iname?authorObj.iname:authorObj.name}}
              <span
                class="author-ise"
              >ISE：{{authorObj.ise}}</span>
              <span class="author-rl">认领尚未开放</span>
              <span @click="openPageError()" class="author-sm">!</span>
            </span>
          </div>
          <div class="intro-company">单位：{{authorObj.icompany?authorObj.icompany:authorObj.company}}</div>
          <div class="intro-field">研究领域：{{authorObj.ikeywords}}</div>
          <!-- <div
            class="intro-intro"
          >学者简介：1980年出生，男，馆员，硕士，东莞理工学院图书馆馆员，主要研究方向国外图书馆。http://1xuezhe.com/ise/scholar?aid=001</div>-->
        </div>
        <div class="wallhaven-chart" id="chart01" :style="{width: '320px', height: '250px'}"></div>
      </div>
    </div>
    <div class="scholar-con">
      <div class="container">
        <div class="scholar-pd clearf">
          <el-col :span="10">
            <h2>主要研究范围</h2>
            <div class="wallhaven-chart" id="chart02" :style="{width: '440px', height: '358px'}"></div>
          </el-col>

          <el-col :span="13" :offset="1">
            <h2>代表作（2009年以来发表）</h2>
            <div style="height:358px">
              <div class="title">{{ispresentObj.title}}</div>
              <div class="con">
                <p>
                  <span>作者：</span>

                  {{ispresentObj.author}}
                </p>
                <p class="keyword" :title="ispresentObj.keywords">
                  <span>关键词：</span>
                  {{ispresentObj.keywords}}
                </p>
                <p>
                  <span>原文出处：</span>
                  《{{ispresentObj.orgpdc}}》 {{ispresentObj.year}}年第{{ispresentObj.orgpdcno}}期
                </p>
                <p class="abstracts" :title="ispresentObj.abstracts">
                  <span>内容提要：</span>
                  {{ispresentObj.abstracts}}
                </p>
                <div class="scholar-link">
                  <a @click="openPageDetail(ispresentObj.pid,ispresentObj.treecode)">更多论文信息 ></a>
                  <a
                    v-if="ispresentObj.rucartid"
                    :href="'https://www.rdfybk.com/qw/detail?id='+ispresentObj.rucartid"
                    target="_blank"
                    class="rdfyk"
                  >人大复印库全文阅读 ></a>
                  <!-- <a href>全文附件 ></a> -->
                </div>
                <div class="shr"></div>
                <p>
                  <span>作者自评：</span>
                  {{"暂无自评"}}
                </p>
                <p class="ise-grade">
                  <span>ISE评级：</span>
                  <span class="ise-score">{{authorObj.ise}}</span>
                  <span class="ise-rz">ISE评议尚未开放</span>
                  <a @click="gotoAbout('introduce')">关于ISE评价？</a>
                  <!-- <a href>查看已开放状态 ></a> -->
                </p>
              </div>
            </div>
          </el-col>
          <!-- <el-col :span="24">
            <h2>个人履历</h2>
            <Personal></Personal>  
          </el-col>-->
          <el-col class="mt30" :span="10">
            <h2>其它成果（2009年以来发表）</h2>
            <div v-if="othersLists.length" class="con-a" v-loading="tableLoad">
              <p v-for="item in othersLists" :key="item['id']">
                <a
                  class="con-a-item"
                  @click="openPageDetail(item.pid,item.treecode)"
                  :title="(item.title)+','+(item.year)"
                >{{item.title}}，{{item.year}}</a>
                <a
                  v-if="item.rucartid && !tableLoad"
                  :href="'https://www.rdfybk.com/qw/detail?id='+item.rucartid"
                  target="_blank"
                  class="rdfyk1"
                  title="人大复印库全文阅读"
                ></a>
              </p>
            </div>

            <div v-if="othersLists.length" class="pagination">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="8"
                layout="prev, pager, next"
                :total="totalcount"
              ></el-pagination>
            </div>
            <div v-if="!othersLists.length" class="no-data">
              <img width="150" height="147" src="../../assets/img/nodata.png" alt>
              <p>暂无其他成果</p>
            </div>
          </el-col>
          <el-col class="mt30" :span="13" :offset="1">
            <h2>
              相关学者
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  箭头方向表示引用了对方的
                  <br>论文，线上的文字表示引用
                  <br>的内容，本图只截取了主要
                  <br>学者之间的引用。
                </div>
                <img style="position: relative;top:21px" src="../../assets/question.svg" alt>
              </el-tooltip>
              <span class="ckdt" v-show="iframeSrc" @click="ckdt">查看大图</span>
            </h2>
            <iframe
              v-if="iframeSrc"
              :src="iframeSrc"
              width="574"
              height="300"
              frameborder="0"
              scrolling="auto"
              style="font-size:14px"
            ></iframe>
            <div v-else-if="!iframeSrc" class="no-data">
              <img width="150" height="147" src="../../assets/img/nodata.png" alt>
              <p>暂无相关学者</p>
            </div>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Personal from "../scholar/personal";
import Paperdetails from "../common/paperdetails";
import Papercomment from "../common/papercomment";
import Paperotherresult from "../common/paperotherresult";
import Paperclaim from "../common/paperclaim";
import Papererror from "../common/papererror";
import { myBrowser } from "../../common/util.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Personal,
    Paperdetails,
    Papercomment,
    Paperotherresult,
    Paperclaim,
    Papererror
  },
  data() {
    //这里存放数据
    return {
      currentPage: 1,
      detailValue: "",
      commentValue: "",
      resultValue: "",
      claimValue: "",
      errorValue: {},
      axisData: [],
      axisNumData: [],
      othersLists: [],
      ispresentObj: {},
      iframeSrc: "",
      authorObj: {},
      substr: "",
      totalcount: 0,
      tableLoad: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    gotoAbout(s) {
      this.$router.push({
        path: `${s}`
      });
    },
    openPageDetail(id, code) {
      this.$nextTick(() => {
        this.$refs.detailKey.open(id, code);
      });
    },
    openPageComment() {
      this.$nextTick(() => {
        this.$refs.commentKey.open();
      });
    },
    openPageResult() {
      this.$nextTick(() => {
        this.$refs.resultKey.open();
      });
    },
    openPageClaim() {
      this.$nextTick(() => {
        this.$refs.claimKey.open();
      });
    },
    openPageError() {
      this.$nextTick(() => {
        this.$refs.errorKey.open(this.authorObj, this.substr);
      });
    },
    ckdt() {
      window.open(this.iframeSrc);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getOthers(this.$route.query.id, this.$route.query.treecode, val);
      console.log(`当前页: ${val}`);
    },
    //获取学者信息
    getiseranklist(id, code) {
      let _this = this;
      let params = {
        aid: id,
        treecode: code
      };
      _this.$api
        .fetchGet("/iseapi/getiseranklist", params)
        .then(res => {
          console.log(res);
          if (res.error === 0) {
            _this.authorObj = res.data[0];
            let arr = [
              _this.authorObj.paper_score,
              _this.authorObj.power_score,
              _this.authorObj.harvest_score
            ];
            let drawData = {
              name: _this.authorObj.name,
              value: arr
            };
            _this.drawLine(drawData);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //主要研究范围
    getResearch(id, code) {
      let _this = this;
      let params = {
        aid: id,
        treecode: code
      };
      _this.$api
        .fetchGet("/iseapi/getisekeywords", params)
        .then(res => {
          if (res.error === 0) {
            res.data.forEach(item => {
              item.score = item.score.toFixed(2);
              _this.axisData.unshift(item.keywords);
              _this.axisNumData.unshift(item.score);
            });
            _this.drawAxis();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取学者主页其他成果
    getOthers(id, code, index) {
      let _this = this;
      _this.tableLoad = true;
      let params = {
        aid: id,
        treecode: code,
        pagesize: 8,
        pageindex: index
      };
      _this.$api
        .fetchGet("/iseapi/getiseotherpaper", params)
        .then(res => {
          if (res.error === 0) {
            _this.othersLists = res.data;
            _this.totalcount = res.totalcount;
            _this.tableLoad = false;
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //代表作品
    getiSerepresent(id, code) {
      let _this = this;
      let params = {
        aid: id,
        treecode: code
      };
      _this.$api
        .fetchGet("/iseapi/getiserepresent", params)
        .then(res => {
          if (res.error === 0) {
            _this.ispresentObj = res.data[0];
            console.log(myBrowser())
            if(myBrowser()){
              _this.ispresentObj.abstracts = _this.ispresentObj.abstracts.substring(0,150) + "..."
            }
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //相关学者
    getScholar(id, code) {
      let _this = this;
      let params = {
        aid: id,
        treecode: code
      };
      _this.$api
        .fetchGet("/iseapi/getisescholargraph", params)
        .then(res => {
          if (res.error === 0) {
            _this.iframeSrc = res.data[0]["graph"];
          }
          //_this.ceshi = res
          //console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },

    drawLine(drawData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart01 = this.$echarts.init(document.getElementById("chart01"));
      // 绘制图表
      myChart01.setOption({
        tooltip: {
          trigger: "axis"
        },
        radar: [
          {
            indicator: [
              { text: "代表作", max: 100 },
              { text: "影响力", max: 100 },
              { text: "活跃度", max: 100 }
            ],
            center: ["50%", "60%"],
            radius: 75,
            name: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item"
            },
            itemStyle: { normal: { areaStyle: { type: "default" } } },
            color: ["#3cb1a7"],
            data: [drawData]
          }
        ]
      });
    },
    drawAxis() {
      // 基于准备好的dom，初始化echarts实例
      let _this = this;
      let myChart02 = this.$echarts.init(document.getElementById("chart02"));
      // 绘制图表
      myChart02.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          top: "0",
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          show: false
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#485465"
            }
          },
          data: _this.axisData
        },
        series: [
          {
            name: "贡献值",
            type: "bar",
            barWidth: "60%",
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ["#76DDFB", "#53A8E2"];
                  if (params.dataIndex % 2 == 1) {
                    return colorList[0];
                  } else {
                    return colorList[1];
                  }
                }
              }
            },
            data: _this.axisNumData
          }
        ]
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log(this.$route.query);
    this.getiseranklist(this.$route.query.id, this.$route.query.treecode);
    this.getResearch(this.$route.query.id, this.$route.query.treecode);
    this.getOthers(this.$route.query.id, this.$route.query.treecode, 1);
    this.getiSerepresent(this.$route.query.id, this.$route.query.treecode);
    this.getScholar(this.$route.query.id, this.$route.query.treecode);
    this.substr = this.$route.query.substr;
    // this.drawLine();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.shr {
  height: 1px;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 25px;
  background-color: #e8e8e8;
}
.mt40 {
  margin-top: 40px;
}
.wallhaven {
  height: 250px;
  min-width: 1200px;
  color: #fff;
  background: url("../../assets/img/wallhaven.png") no-repeat;
}
.wallhaven-img {
  margin-top: 40px;
  margin-right: 15px;
  float: left;
}
.wallhaven-img,
.wallhaven-intro,
.wallhaven-chart {
  display: inline-block;
}
.wallhaven-intro {
  padding-top: 40px;
  font-size: 14px;
  max-width: 700px;
  color: #fff;
}
.wallhaven-chart {
  float: right;
  text-align: center;
}
.intro-route {
  margin-bottom: 15px;
}
.intro-author .author {
  font-size: 18px;
  line-height: 24px;
}
.intro-author .author .author-ise {
  background-color: #b38e65;
  padding: 2px 8px;
  font-size: 14px;
  color: #fff;
  border-radius: 2px;
  margin-left: 5px;
}
.intro-author .author .author-rl {
  padding: 2px 12px;
  background-color: #4267b2;
  font-size: 14px;
  color: #fff;
  border-radius: 2px;
  margin-left: 5px;
}
.intro-author .author .author-sm {
  background-color: #ccd2df;
  display: inline-block;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 10px;
  color: #4267b2;
  line-height: 20px;
  padding: 1px;
  margin-left: 5px;
  position: relative;
  top: 2px;
  cursor: pointer;
}
.intro-company {
  margin-top: 20px;
}
.scholar-pd {
  padding: 30px 70px;
  background-color: #fff;
}
.scholar-con {
  box-sizing: border-box;
  background-color: #f6f6f6;
}
.scholar-con h2 {
  height: 60px;
  line-height: 60px;
  padding-left: 14px;
  font-size: 16px;
  color: #4267b2;
  position: relative;
  margin-bottom: 20px;
  background: #fbfbfb;
}
.scholar-con h2:before {
  content: "";
  width: 4px;
  height: 20px;
  position: absolute;
  left: 0px;
  top: 19px;
  background-color: #4267b2;
}
.title {
  color: #000;
  font-weight: 600;
  margin-bottom: 15px;
}
.con {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}
.con p {
  line-height: 24px;
}
.scholar-link {
  margin-top: 20px;
}
.scholar-pd a {
  color: #4267b2;
  margin-right: 10px;
}
.con-a .con-a-item {
  display: inline-block;
  max-width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.con-a p {
  line-height: 30px;
  height: 30px;
  font-size: 14px;
  position: relative;
}
.con-a .rdfyk1 {
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  position: absolute;
  height: 14px;
  width: 16px;
  top: 8px;
}
.abstracts {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.keyword {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.pagination {
  margin-top: 30px;
  text-align: right;
}
.ise-grade .ise-score {
  background-color: #d9d9d9;
  box-sizing: border-box;
  border: 1px solid #f5f5f5;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  padding: 2px 8px;
  border-radius: 3px;
  margin-right: 8px;
}
.ise-grade .ise-rz {
  background-color: #4267b2;
  box-sizing: border-box;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  padding: 3px 8px;
  border-radius: 3px;
  margin-right: 8px;
}
.ckdt {
  float: right;
  font-size: 14px;
  font-weight: 500;
}
.ckdt:hover {
  cursor: pointer;
}
.scholar-link .rdfyk::before {
  content: " ";
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 2px;
  display: inline-block;
  height: 14px;
  width: 16px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4267b2 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/home/homepage.vue